import { useMutation, useQueryClient } from '@tanstack/react-query'
import NamedValuesService from '../../../services/NamedValues.service'

type UpdateNamedValuePayload = {
  organization: string
  oldName: string
  name: string
}

export const useUpdateVariableName = () => {
  const queryClient = useQueryClient()

  return useMutation<any, Error, UpdateNamedValuePayload>({
    mutationKey: ['named-value-update-name'],
    mutationFn: (payload) => NamedValuesService.updateName(payload.organization, payload.name, payload.oldName),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['named-values'] })
    },
  })
}
